import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { getOrderManagementModuleName } from './order-management.permissions';

export class OrdersPermissions {
  static GroupName = `${getOrderManagementModuleName()}.Orders`;

  static getPermissions = getGroupPermissionFactory(OrdersPermissions.GroupName);

  static Permissions = {
    Read: OrdersPermissions.getPermissions(PermissionEnum.READ),
    ReadAll: OrdersPermissions.getPermissions(PermissionEnum.READ_ALL),
    Process: OrdersPermissions.getPermissions("Process"),
    Cancel: OrdersPermissions.getPermissions("Cancel"),
    QuickCreate: OrdersPermissions.getPermissions("QuickCreate"),
  };
}
